import { useQuery } from 'react-query';
import { getAccountInventory } from '../sp-firebase/inventoryFB';
import { useAccountStore } from '../components/Stores/accountStore';

const fetchInventoryByAccount = async (accountId: string) => {
  if (!accountId) return;
  try {
    const inventory = await getAccountInventory(accountId);
    if (inventory) {
      return inventory;
    }
    throw new Error('Failed to fetch inventory');
  } catch (error) {
    console.error('Error fetching inventory:', error);
    throw error;
  }
};

export const useInventory = () => {
  const { account } = useAccountStore();
  const enable = false; // account.id !== undefined;
  const fetchFunction = () => fetchInventoryByAccount(account.id || '');
  return useQuery('Inventory', fetchFunction, { enabled: enable });
};
